import React from "react";

import storage from "commons/utils/storage";

export type AuthType = {
    accessToken: string;
};

export const AuthContext = React.createContext({
    setAccessToken: (accessToken: string) => {
        console.error("Undefined function -> setAccessToken");
    },
    getAccessToken: (): string => {
        console.error("Undefined function -> getAccessToken");

        return "";
    },
});

export const useAuthContext = () => React.useContext(AuthContext);

type PropsType = {
    children: JSX.Element;
};

const setAuth = (auth: AuthType) => {
    storage.set("auth", auth);
};

const getAuth = (): AuthType => {
    let store: AuthType = storage.get("auth");

    if (!store) {
        store = { accessToken: "" };
    }

    return store;
};

export const AuthContextProvider = (props: PropsType) => {
    const setAccessToken = React.useCallback((accessToken: string) => {
        setAuth({ accessToken });
    }, []);

    const getAccessToken = React.useCallback((): string => {
        const storedAuth = getAuth();

        return storedAuth.accessToken;
    }, []);

    const authContextValues = React.useMemo(
        () => ({ setAccessToken, getAccessToken }),
        [setAccessToken, getAccessToken]
    );

    return <AuthContext.Provider value={authContextValues}>{props.children}</AuthContext.Provider>;
};
